// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

angular
  .module('landingPage')
  .service('StartPageService', function ($q, $location) {
    const startPageService = {
      setStartPagePreference(pref) {
        const deferred = $q.defer();
        $.ajax({
          type: 'POST',
          data: { start_page: pref },
          url: siteMap.cleanRelativePath('/start-page'),
          success(response) {
            return deferred.resolve(response);
          },
          error(error) {
            return deferred.reject(error);
          },
        });
        return deferred.promise;
      },
    };

    return startPageService;
  });
